import { faChevronDown, faChevronUp, faClipboardList, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Badge, Button, Card, Col, OverlayTrigger, Placeholder, Row, Tooltip } from "react-bootstrap";
import { EXPLAIN_DDX } from "../../../amplify/api-gateway/write";
import { FakeLoadingBar } from "../../dashboard/llm/common/FakeLoadingBar";
import { LLMDashboardFeedbackBar } from "../../dashboard/llm/common/LLMDashboardFeedbackBar";
import { LLMDashboardUpdated } from "../../dashboard/llm/common/LLMDashboardUpdated";
import { isSectionUnread } from "../../dashboard/llm/utils";
import TriStateChecklist from "./TriStateChecklist";
import ActionableIntelligenceTracker from "./ActionableIntelligenceTracker";
import { ACTIONABLE_ITEMS_FOR_VISIT, callQuery } from "../../../amplify/api-gateway/query";
import { ActionableItem } from "../../dashboard/llm/common/models";


export const SectionTrackboardNextSteps = ({
    className='',
    isLoadingDdx,
    ddx,
    tenant,
    patientVisit,
    feedbacks,
    setFeedbacks,
    statuses,
    setRegenerateTarget,
    setShowContextMenu,
    existingNextSteps,
    setExistingNextSteps,
    handleShowScanMultiModal,
    unreadFileVersionMap = undefined,
    latestFileVersions = undefined,
    sectionToSetter = undefined,
    handleFileVersionChange = undefined,
}: any) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [actionableItems, setActionableItems] = useState<ActionableItem[]>([]);

    useEffect(() => {
        if (ddx && patientVisit) {
            setIsLoading(true);
            callQuery({
                operation: ACTIONABLE_ITEMS_FOR_VISIT,
                mrn: patientVisit.mrn,
                csn: patientVisit.csn,
            })
            .then((actionableItems: ActionableItem[]) => {
                setIsLoading(false);
                setActionableItems(actionableItems);
            });
        }
    }, [ddx, patientVisit]);

    // Hide Actionable Items section entirely until DDx is generated
    // (Actionable Items are produced by the DDx generation process)
    if (!isLoadingDdx && (!ddx || ddx["error"])) {
        return null;
    }

    return (
        <Card className={`fade-in ${className}`}>
            <FakeLoadingBar isActive={isLoadingDdx} maxDuration={30000} />
            <Card.Body>
                <Row>
                    <Col md={4}>
                        <div className="d-flex align-items-center">
                            <span className={`dashboard-actions-circle-small dashboard-actions-circle-blue me-2`}><FontAwesomeIcon icon={faClipboardList} fixedWidth /></span><strong>Actionable Items</strong> {isSectionUnread(EXPLAIN_DDX, unreadFileVersionMap) && <Badge bg="info" className="ms-2">NEW</Badge>}
                        </div>
                    </Col>
                    <Col md={8} className="text-right">
                        <LLMDashboardUpdated patient={patientVisit} statuses={statuses} handleShowScanMultiModal={handleShowScanMultiModal} latestFileVersions={latestFileVersions} explainKey={"explain_ddx"} sectionToSetter={sectionToSetter} handleFileVersionChange={handleFileVersionChange} />
                        
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip>
                                    Refresh Section
                                </Tooltip>
                            }
                        >
                            <Button
                                variant="primary"
                                className="dashboard-round-btn"
                                onClick={(e: any) => {e.stopPropagation(); setRegenerateTarget(EXPLAIN_DDX); setShowContextMenu(true)}}
                            >
                                <FontAwesomeIcon icon={faRefresh} />
                            </Button>
                        </OverlayTrigger>
                        <LLMDashboardFeedbackBar patientVisit={patientVisit} feedbackTarget={"ddx"} feedbacks={feedbacks} setFeedbacks={setFeedbacks} />
                        <Button
                            variant="primary"
                            className="dashboard-round-btn"
                            onClick={(e: any) => {e.stopPropagation(); setIsExpanded(!isExpanded)}}
                        >
                            <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
                        </Button>
                    </Col>
                </Row>
                {isExpanded && (
                    <>
                        <Row className="mt-2">
                            <Col md={12} className="description-text">
                                {
                                    isLoadingDdx || isLoading ? (
                                        <Placeholder animation="glow">
                                            <Placeholder xs={4} />
                                        </Placeholder>
                                    ) : ddx && ddx["actionable_items"] ? (
                                        <>
                                            <ActionableIntelligenceTracker tenant={tenant} patient={patientVisit} items={actionableItems} setItems={setActionableItems} />
                                        </>
                                    ) : ddx && ddx["next_steps"] ? (
                                        <>
                                            <TriStateChecklist data={ddx["next_steps"]} existingNextSteps={existingNextSteps} setExistingNextSteps={setExistingNextSteps} />
                                        </>
                                    ) : (
                                        <>No Data</>
                                    )
                                }
                            </Col>
                        </Row>
                        
                    </>
                )}
            </Card.Body>
        </Card>
    );
};
